import { useState } from 'react';
import type { PtoProject } from '@shared/api';
import { Select, WideInput } from './styles';

/** Все доступные проекты; сервер по умолчанию отдаёт только первые 50. */
export const PROJECTS_LIMIT = 1000;
const SEARCH_FROM = 12;

export function projectLabel(p: Pick<PtoProject, 'name' | 'code'>): string {
  return p.code ? `${p.name} · ${p.code}` : p.name;
}

/** Один явный выбор для всего пакета, без автоматического выбора по шифрам РД. */
export function ProjectPicker({
  projectId,
  projects,
  loading,
  locked,
  onPick,
}: {
  projectId: string | null;
  projects: PtoProject[];
  loading: boolean;
  locked: boolean;
  onPick: (projectId: string | null) => void;
}) {
  const [query, setQuery] = useState('');
  const q = query.trim().toLowerCase();
  const shown = projects.filter(
    (p) => p.id === projectId || !q || `${p.name} ${p.code ?? ''}`.toLowerCase().includes(q),
  );
  return (
    <>
      {projects.length > SEARCH_FROM ? (
        <WideInput
          type="search"
          value={query}
          disabled={locked}
          placeholder="Найти проект: наименование или шифр"
          aria-label="Поиск проекта для загрузки РД"
          onChange={(e) => setQuery(e.target.value)}
        />
      ) : null}
      <Select
        value={projectId ?? ''}
        disabled={locked}
        aria-label="Проект для загрузки РД"
        onChange={(e) => onPick(e.target.value || null)}
      >
        <option value="">— выберите проект —</option>
        {shown.map((p) => (
          <option key={p.id} value={p.id}>
            {projectLabel(p)}
          </option>
        ))}
        {loading ? <option disabled>загружаем список проектов…</option> : null}
        {!loading && shown.length === 0 ? <option disabled>проекты не найдены</option> : null}
      </Select>
    </>
  );
}
